// https://youmightnotneed.com/lodash#isString
export const isString = (a) => typeof a === 'string'

// https://youmightnotneed.com/lodash#isObject
export const isObject = (a) => a instanceof Object

// https://youmightnotneed.com/lodash#isNumber
export const isNumber = (a) => typeof a === 'number'
